import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import Maintenance from "./components/Maintenance";

const root = ReactDOM.createRoot(document.getElementById("root"));
const isMaintenanceMode = false;
root.render(
  <React.StrictMode>
    <BrowserRouter>
      {isMaintenanceMode ? <Maintenance /> : <App />}
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
